import { defineMessages } from "react-intl";

export const boardBasisMessages = defineMessages({
  AI: { defaultMessage: "All inclusive", description: "hotels.boardBasis.AI" },
  BB: {
    defaultMessage: "Bed & breakfast",
    description: "hotels.boardBasis.BB",
  },
  FB: { defaultMessage: "Full board", description: "hotels.boardBasis.FB" },
  HB: { defaultMessage: "Half board", description: "hotels.boardBasis.HB" },
  RD: {
    defaultMessage: "Checkroom available",
    description: "hotels.boardBasis.RD",
  },
  RO: {
    defaultMessage: "1x Room / Room Only",
    description: "hotels.boardBasis.RO",
  },
  SC: { defaultMessage: "Self catering", description: "hotels.boardBasis.SC" },
});

export function isKnownBoardBasis(
  value: string,
): value is keyof typeof boardBasisMessages {
  return Object.keys(boardBasisMessages).includes(value);
}
